/**
 * @generated SignedSource<<73dce6d5f6a355ae9c2d255802b6a2ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectDirectoryQuery$variables = {
  aaid?: string | null;
  workspaceId?: string | null;
  workspaceUuid: string;
};
export type ProjectDirectoryQuery$data = {
  readonly customFieldDefinitionTql: {
    readonly " $fragmentSpreads": FragmentRefs<"buildCustomFieldResolvers">;
  } | null;
  readonly customfieldHeaderSupport: {
    readonly " $fragmentSpreads": FragmentRefs<"ProjectDirectoryHeaderColumns">;
  } | null;
  readonly hasProjects: {
    readonly hasRecords: boolean;
  } | null;
  readonly reportingLines: {
    readonly managers: ReadonlyArray<{
      readonly __typename: "ReportingLinesUser";
    } | null> | null;
    readonly peers: ReadonlyArray<{
      readonly __typename: "ReportingLinesUser";
    } | null> | null;
    readonly reports: ReadonlyArray<{
      readonly __typename: "ReportingLinesUser";
    } | null> | null;
  } | null;
};
export type ProjectDirectoryQuery = {
  response: ProjectDirectoryQuery$data;
  variables: ProjectDirectoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aaid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceUuid"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "args": [
    {
      "kind": "Variable",
      "name": "aaidOrHash",
      "variableName": "aaid"
    }
  ],
  "concreteType": "ReportingLines",
  "kind": "LinkedField",
  "name": "reportingLines",
  "plural": false,
  "selections": [
    {
      "concreteType": "ReportingLinesUser",
      "kind": "LinkedField",
      "name": "managers",
      "plural": true,
      "selections": (v2/*: any*/)
    },
    {
      "concreteType": "ReportingLinesUser",
      "kind": "LinkedField",
      "name": "peers",
      "plural": true,
      "selections": (v2/*: any*/)
    },
    {
      "concreteType": "ReportingLinesUser",
      "kind": "LinkedField",
      "name": "reports",
      "plural": true,
      "selections": (v2/*: any*/)
    }
  ]
},
v4 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeArchived",
      "value": false
    },
    {
      "kind": "Variable",
      "name": "workspaceId",
      "variableName": "workspaceId"
    }
  ],
  "concreteType": "HasRecords",
  "kind": "LinkedField",
  "name": "hasProjects",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasRecords"
    }
  ]
},
v5 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v6 = [
  {
    "kind": "Literal",
    "name": "q",
    "value": "(entityType = PROJECT AND (type != String OR hasPredefinedValues = true))"
  },
  (v5/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "ScalarField",
  "name": "token"
},
v9 = {
  "kind": "ScalarField",
  "name": "canSetMultipleValues"
},
v10 = {
  "kind": "ScalarField",
  "name": "value"
},
v11 = [
  {
    "kind": "Literal",
    "name": "q",
    "value": "entityType = PROJECT"
  },
  (v5/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    (v12/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v14 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v15 = {
  "kind": "ScalarField",
  "name": "type"
},
v16 = [
  (v14/*: any*/),
  (v7/*: any*/),
  (v15/*: any*/)
],
v17 = [
  (v14/*: any*/),
  (v7/*: any*/),
  (v15/*: any*/),
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectDirectoryQuery",
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "args": (v6/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "buildCustomFieldResolvers",
            "selections": [
              {
                "concreteType": "CustomFieldDefinitionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "buildCustomFieldResolvers_userResolver",
                            "selections": [
                              (v1/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/)
                            ],
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "UserCustomFieldDefinition"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "buildCustomFieldResolvers_textSelectResolver",
                            "selections": [
                              (v1/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              {
                                "concreteType": "CustomFieldTextAllowedValueConnection",
                                "kind": "LinkedField",
                                "name": "allowedValues",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CustomFieldTextAllowedValueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextAllowedValueNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "TextSelectCustomFieldDefinition"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "buildCustomFieldResolvers_numberResolver",
                            "selections": [
                              (v1/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/)
                            ],
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "NumberCustomFieldDefinition"
                      }
                    ]
                  }
                ]
              }
            ],
            "argumentDefinitions": []
          }
        ]
      },
      {
        "alias": "customfieldHeaderSupport",
        "args": (v11/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ProjectDirectoryHeaderColumns"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectDirectoryQuery",
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "args": (v6/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFieldDefinitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ],
                    "type": "UserCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "concreteType": "CustomFieldTextAllowedValueConnection",
                        "kind": "LinkedField",
                        "name": "allowedValues",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CustomFieldTextAllowedValueEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "CustomFieldTextAllowedValueNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v12/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "TextSelectCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "type": "NumberCustomFieldDefinition"
                  },
                  (v13/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "customfieldHeaderSupport",
        "args": (v11/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFieldDefinitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v16/*: any*/),
                    "type": "NumberCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v16/*: any*/),
                    "type": "TextCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v17/*: any*/),
                    "type": "TextSelectCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v17/*: any*/),
                    "type": "UserCustomFieldDefinition"
                  },
                  (v13/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "4ed1b69ea4e01b07fcfc19efe8e44f49",
    "id": null,
    "metadata": {},
    "name": "ProjectDirectoryQuery",
    "operationKind": "query",
    "text": "query ProjectDirectoryQuery(\n  $aaid: String\n  $workspaceId: ID\n  $workspaceUuid: UUID!\n) {\n  reportingLines(aaidOrHash: $aaid) {\n    managers {\n      __typename\n    }\n    peers {\n      __typename\n    }\n    reports {\n      __typename\n    }\n  }\n  hasProjects(includeArchived: false, workspaceId: $workspaceId) {\n    hasRecords\n  }\n  customFieldDefinitionTql(q: \"(entityType = PROJECT AND (type != String OR hasPredefinedValues = true))\", workspaceUuid: $workspaceUuid) {\n    ...buildCustomFieldResolvers\n  }\n  customfieldHeaderSupport: customFieldDefinitionTql(q: \"entityType = PROJECT\", workspaceUuid: $workspaceUuid) {\n    ...ProjectDirectoryHeaderColumns\n  }\n}\n\nfragment ProjectDirectoryHeaderColumns on CustomFieldDefinitionConnection {\n  edges {\n    node {\n      __typename\n      ... on NumberCustomFieldDefinition {\n        uuid\n        name\n        type\n      }\n      ... on TextCustomFieldDefinition {\n        uuid\n        name\n        type\n      }\n      ... on TextSelectCustomFieldDefinition {\n        uuid\n        name\n        type\n        canSetMultipleValues\n      }\n      ... on UserCustomFieldDefinition {\n        uuid\n        name\n        type\n        canSetMultipleValues\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment buildCustomFieldResolvers on CustomFieldDefinitionConnection {\n  edges {\n    node {\n      __typename\n      ... on UserCustomFieldDefinition {\n        ...buildCustomFieldResolvers_userResolver\n      }\n      ... on TextSelectCustomFieldDefinition {\n        ...buildCustomFieldResolvers_textSelectResolver\n      }\n      ... on NumberCustomFieldDefinition {\n        ...buildCustomFieldResolvers_numberResolver\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment buildCustomFieldResolvers_numberResolver on NumberCustomFieldDefinition {\n  __typename\n  name\n  token\n}\n\nfragment buildCustomFieldResolvers_textSelectResolver on TextSelectCustomFieldDefinition {\n  __typename\n  name\n  token\n  canSetMultipleValues\n  allowedValues {\n    edges {\n      node {\n        value\n        id\n      }\n    }\n  }\n}\n\nfragment buildCustomFieldResolvers_userResolver on UserCustomFieldDefinition {\n  __typename\n  name\n  token\n  canSetMultipleValues\n}\n"
  }
};
})();

(node as any).hash = "b6bf8a4247fc033fa10295a5ccbab8eb";

export default node;
